import React from 'react';
import { Button } from '@finect/tabular-core/Button';
import { Inner } from './partials';
export var ProductCTA = function ProductCTA(_ref) {
  var actions = _ref.actions,
    product = _ref.product;
  var handleProductCTA = function handleProductCTA() {
    actions && actions.productCTA && actions.productCTA();
  };
  var transactionable = product.entity.transactionable;
  return React.createElement(Inner, null, React.createElement(Button, {
    onClick: handleProductCTA,
    secondary: true,
    width: "auto",
    disabled: !transactionable
  }, 'Comenzar la contratación'));
};